import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
const FACTOR_COLORS = {
    overall: '#3b82f6',
    budget: '#10b981',
    schedule: '#f59e0b',
    execution: '#8b5cf6',
    resource: '#ec4899',
    dataQuality: '#6b7280',
};
const FACTOR_LABELS = {
    overall: 'Overall',
    budget: 'Budget',
    schedule: 'Schedule',
    execution: 'Execution',
    resource: 'Resource',
    dataQuality: 'Data Quality',
};
export const HealthTrendChart = ({ data, height = 200, }) => {
    const [activeLines, setActiveLines] = React.useState(new Set(['overall']));
    if (!data || data.length === 0) {
        return (_jsx("div", { className: "text-center text-gray-500 py-8", children: "No health trend data available. Scores are calculated daily." }));
    }
    const toggleLine = (key) => {
        setActiveLines(prev => {
            const next = new Set(prev);
            if (next.has(key)) {
                if (next.size > 1)
                    next.delete(key);
            }
            else {
                next.add(key);
            }
            return next;
        });
    };
    const padding = { top: 20, right: 20, bottom: 30, left: 40 };
    const width = 600;
    const chartWidth = width - padding.left - padding.right;
    const chartHeight = height - padding.top - padding.bottom;
    const getY = (score) => {
        return padding.top + chartHeight - (score / 100) * chartHeight;
    };
    const getX = (index) => {
        return padding.left + (index / Math.max(1, data.length - 1)) * chartWidth;
    };
    const buildPath = (key) => {
        const points = data.map((point, i) => {
            const scoreKey = key === 'overall' ? 'overallScore'
                : key === 'budget' ? 'budgetScore'
                    : key === 'schedule' ? 'scheduleScore'
                        : key === 'execution' ? 'executionScore'
                            : key === 'resource' ? 'resourceScore'
                                : 'dataQualityScore';
            const x = getX(i);
            const y = getY(point[scoreKey]);
            return `${i === 0 ? 'M' : 'L'} ${x} ${y}`;
        });
        return points.join(' ');
    };
    // Y-axis gridlines
    const gridlines = [0, 20, 40, 60, 80, 100];
    return (_jsxs("div", { children: [_jsx("div", { className: "flex flex-wrap gap-3 mb-3", children: Object.entries(FACTOR_LABELS).map(([key, label]) => (_jsxs("button", { onClick: () => toggleLine(key), className: `flex items-center gap-1 text-xs px-2 py-1 rounded border transition-colors ${activeLines.has(key)
                        ? 'border-gray-400 bg-white shadow-sm'
                        : 'border-gray-200 bg-gray-50 opacity-50'}`, children: [_jsx("div", { className: "w-3 h-0.5 rounded", style: { backgroundColor: FACTOR_COLORS[key] } }), label] }, key))) }), _jsxs("svg", { viewBox: `0 0 ${width} ${height}`, className: "w-full", children: [gridlines.map(val => (_jsxs("g", { children: [_jsx("line", { x1: padding.left, y1: getY(val), x2: width - padding.right, y2: getY(val), stroke: "#e5e7eb", strokeDasharray: val === 0 || val === 100 ? '' : '4 4' }), _jsx("text", { x: padding.left - 5, y: getY(val) + 4, textAnchor: "end", className: "text-[10px] fill-gray-400", children: val })] }, val))), _jsx("rect", { x: padding.left, y: getY(100), width: chartWidth, height: getY(80) - getY(100), fill: "#dcfce7", opacity: 0.3 }), _jsx("rect", { x: padding.left, y: getY(60), width: chartWidth, height: getY(40) - getY(60), fill: "#fef3c7", opacity: 0.3 }), _jsx("rect", { x: padding.left, y: getY(40), width: chartWidth, height: getY(0) - getY(40), fill: "#fee2e2", opacity: 0.3 }), Object.keys(FACTOR_LABELS).map(key => {
                        if (!activeLines.has(key))
                            return null;
                        return (_jsx("path", { d: buildPath(key), fill: "none", stroke: FACTOR_COLORS[key], strokeWidth: key === 'overall' ? 2.5 : 1.5, strokeLinecap: "round", strokeLinejoin: "round" }, key));
                    }), data.map((point, i) => {
                        // Show max 7 labels
                        if (data.length > 7 && i % Math.ceil(data.length / 7) !== 0 && i !== data.length - 1)
                            return null;
                        const date = new Date(point.snapshotDate);
                        const label = `${date.getMonth() + 1}/${date.getDate()}`;
                        return (_jsx("text", { x: getX(i), y: height - 5, textAnchor: "middle", className: "text-[10px] fill-gray-400", children: label }, i));
                    })] })] }));
};
//# sourceMappingURL=HealthTrendChart.js.map